import {isNil} from 'ramda';

import {UserAbsenceResponseBody} from '@dms/api/shared';

import {parseDate} from 'shared/web';

export function getPlannedAbsence(
  absences: UserAbsenceResponseBody[] | undefined,
  nowIso: string
): UserAbsenceResponseBody | null {
  if (isNil(absences)) {
    return null;
  }

  const now = parseDate(nowIso).getTime();

  const futureAbsences = absences
    .filter((absence) => parseDate(absence.dateFrom).getTime() > now)
    .sort((a, b) => parseDate(a.dateFrom).getTime() - parseDate(b.dateFrom).getTime()); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

  return futureAbsences[0] ?? null;
}
